import { AsyncState, Updater, unloadedAsyncState } from 'widgets-for-react'
import { loadDeleteCollection } from './collectionDeleterApi'

export type CollectionDeleterState = {
  opened: boolean
  deletingState: AsyncState<{}>
  componentId?: number
}

export const initialCollectionDeleterState: CollectionDeleterState = {
  opened: false,
  deletingState: unloadedAsyncState(),
}

export const collectionDeleterStateUpdaters = {
  startDeletingUpdater:
    (componentId?: number) =>
    (
      currentState: CollectionDeleterState
    ): CollectionDeleterState & { reloadCollections: boolean } => ({
      ...currentState,
      opened: true,
      componentId: componentId,
      deletingState: unloadedAsyncState(),
      reloadCollections: false,
    }),
  stopDeletingUpdater: (
    currentState: CollectionDeleterState
  ): CollectionDeleterState & { reloadCollections: boolean } => ({
    ...currentState,
    opened: false,
    reloadCollections: false,
  }),
  deletingStateUpdater:
    (update: Updater<AsyncState<{}>>) =>
    (
      currentState: CollectionDeleterState
    ): CollectionDeleterState & { reloadCollections: boolean } => {
      const newState = update(currentState.deletingState)
      const toLoadedUpdate =
        currentState.deletingState.kind != 'loaded' && newState.kind == 'loaded'
      return toLoadedUpdate
        ? {
            ...collectionDeleterStateUpdaters.stopDeletingUpdater(currentState),
            deletingState: newState,
            reloadCollections: true,
          }
        : {
            ...currentState,
            deletingState: newState,
            reloadCollections: false,
          }
    },
  startLoadingDeletingStateUpdater:
    (collectionId: string, componentId?: number) =>
    (
      currentState: CollectionDeleterState
    ): CollectionDeleterState & { reloadCollections: boolean } =>
      currentState.opened
        ? {
            ...currentState,
            deletingState: loadDeleteCollection(collectionId, componentId),
            reloadCollections: false,
          }
        : { ...currentState, reloadCollections: false },
}
